import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgreementRepository } from "../../repositories/agreement.repository";

export interface ChangeStatusUseCaseParam {
  agreementId: number;
}

export class ChangeStatusUseCase
  implements UseCase<ChangeStatusUseCaseParam, string>
{
  constructor(private repo: AgreementRepository) {}
  execute(param: ChangeStatusUseCaseParam): Observable<string> {
    return this.repo.changeStatus(param.agreementId);
  }
}

const changeStatusUseCaseFactory = (repo: AgreementRepository) =>
  new ChangeStatusUseCase(repo);

export const changeStatusUseCaseProvider: Provider = {
  provide: ChangeStatusUseCase,
  useFactory: changeStatusUseCaseFactory,
  deps: [AgreementRepository],
};
